import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    emoji: '📗',
    title: 'TOMO 1 — EL DESPEGUE',
    desc: 'Mentalidad, medición inicial y por qué fallan todos los métodos anteriores. La base que hace posibles los 14 días siguientes.'
  }, {
    emoji: '📙',
    title: 'TOMO 2 — EL CIRCUITO DE FUEGO',
    desc: '10 ejercicios, 2 circuitos progresivos, Vacuum Abdominal completo y timer exacto. 15 minutos. Sin equipamiento. Sin excusas.'
  }, {
    emoji: '📕',
    title: 'TOMO 3 — NUTRICIÓN ARGENTINA',
    desc: 'Plan de comidas para los 15 días con ingredientes del súper del barrio. 12 recetas en 10 minutos. Guía para el asado, el delivery y los eventos sociales.'
  }, {
    emoji: '📘',
    title: 'TOMO 4 — DETOX & HIDRATACIÓN',
    desc: '10 infusiones anti-hinchazón, 6 aguas saborizadas, mate inteligente y drenaje linfático manual de 5 minutos. El abdomen se desinfla en 48 horas.'
  }, {
    emoji: '📓',
    title: 'TOMO 5 — EL DIARIO DE 15 DÍAS',
    desc: '15 fichas diarias listas, tabla de progreso visual, mediciones en días clave y el Contrato Personal con los Resultados.'
  }, {
    emoji: '📒',
    title: 'TOMO 6 — MANTENIMIENTO',
    desc: 'Cómo no recuperar nada. Plan de 10 minutos × 4 días por semana. La Regla 80/20. La Semana de Recalibración para cuando se va de control.'
  }];
  const checks = ['Adaptado 100% a la realidad argentina', 'Ingredientes del supermercado del barrio', 'Sin equipamiento ni gimnasio', 'Compatible con asado, trabajo y vida social', 'Diseñado para personas sin experiencia previa'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-232">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-233">
        <span className="text-brand-green font-bold tracking-wider text-sm mb-4 block uppercase" data-id="element-234">
          🏆 SUPERPACK ABDOMEN PLANO EN 15 DÍAS
        </span>
        <h2 className="text-4xl md:text-5xl font-black leading-tight" data-id="element-235">
          6 Tomos + 6 Bonos
          <br data-id="element-236" />
          <span className="text-brand-green" data-id="element-237">Todo Resuelto</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-238">
        {tomos.map((tomo, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-brand-green/10 hover:border-brand-green/40 transition-colors rounded-2xl p-8 flex flex-col gap-4" data-id="element-239">
            <div className="text-4xl" data-id="element-240">{tomo.emoji}</div>
            <h3 className="text-xl font-black text-white" data-id="element-241">{tomo.title}</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-242">{tomo.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-brand-card border border-brand-green/30 rounded-2xl p-8 md:p-10 max-w-3xl mx-auto" data-id="element-243">
        <h4 className="text-xl font-bold mb-6 text-center" data-id="element-244">
          Cada tomo incluye:
        </h4>
        <div className="space-y-4" data-id="element-245">
          {checks.map((check, i) => <div key={i} className="flex items-center gap-3" data-id="element-246">
              <div className="bg-brand-green/20 p-1 rounded-full shrink-0" data-id="element-247">
                <Check className="w-5 h-5 text-brand-green" data-id="element-248" />
              </div>
              <span className="text-gray-200 font-medium" data-id="element-249">{check}</span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}